import { useCallback } from "react"
import { Chip, IconButton, Stack, Tooltip } from "@mui/material"
import {
	FileDownload as FileDownloadIcon,
	FilterAltOutlined as UnFilterIcon,
	ViewColumn as ViewColumnIcon,
	ViewColumnOutlined as UnViewColumnIcon
} from '@mui/icons-material'
import { FilterIcon } from "shared/icons"

import { useGrid } from "components/grid"

export const GridBar = ({
	functionsRef,
	filters, setFilters,
	showColumnManage, setShowColumnManage,
	showFilterManage, setShowFilterManage
}: ReturnType<typeof useGrid>) => {
	const onDeleteFilter = useCallback(
		(field: string) => {
			setFilters(filters.filter(f => f.field !== field).slice())
		},
		[filters, setFilters]
	)
  return (
    <Stack direction="row" spacing={1} paddingY={0.5} paddingX={1} alignItems="center">
			<Stack flexGrow={1} direction="row" flexWrap="wrap" alignItems="center" spacing={1} useFlexGap>
				{filters?.map((filter, i) => (
					<Chip
						key={`filter-${i}-${filter.field}`}
						label={filter.label ?? '???'}
						variant="outlined"
						onDelete={() => onDeleteFilter(filter.field)}
						sx={{ maxWidth: '20em' }}
					/>
				))}
			</Stack>

			<Stack direction="row" paddingX={1} alignItems="center">
				<Tooltip title="フィルター" placement="bottom-end">
					<IconButton
						color={showFilterManage ? 'primary' : 'default'}
						onClick={() => setShowFilterManage(!showFilterManage)}
					>
						{showFilterManage ? <FilterIcon/> : <UnFilterIcon/>}
					</IconButton>
				</Tooltip>

				<Tooltip title="列管理" placement="bottom-end">
					<IconButton
						color={showColumnManage ? 'primary' : 'default'}
						onClick={() => setShowColumnManage(!showColumnManage)}
					>
						{showColumnManage ? <ViewColumnIcon/> : <UnViewColumnIcon/>}
					</IconButton>
				</Tooltip>

				<Tooltip title="ダウンロード" placement="bottom-end">
					<IconButton
						disabled={functionsRef.current === null || functionsRef.current.dataLength === 0}
						onClick={() => functionsRef.current?.download()}
					>
						<FileDownloadIcon/>
					</IconButton>
				</Tooltip>
			</Stack>
		</Stack>
	)
}
